const utilities = {
  install(Vue) {
    Vue.prototype.$utilities = {
      // example: How to call function
      // 1.) this.$utils('functionsName', {Parameters})
      // 2.) Vue.prototype.$utilities.functionName(Parameters)
      acronymName: (value) => {
        // 1.) { fullName: 'string' }
        // 2.) { firstName: 'string', lastName: 'string' }
        let firstNameText, lastNameText
        if (value.fullName) {
          firstNameText = value.fullName.split(" ")[0].charAt(0)
          lastNameText = value.fullName.split(" ").reverse()[0].charAt(0)
          if (firstNameText === lastNameText) { lastNameText = "" }
        } else {
          firstNameText = value.firstName ? value.firstName.charAt(0) : ""
          lastNameText = value.lastName ? value.lastName.charAt(0) : ""
        }
        return firstNameText + lastNameText
      },
      addCommasInNumber: (value = 0) => {
        let input = 0
        if (value === null) {
          return "-";
        }
        if (typeof value === 'string') {
          const valueAsNumber = parseFloat(value);
          if (!isNaN(valueAsNumber)) {
            input = valueAsNumber;
          }
        } else {
          input = value;
        }
       
        const [integerPart, decimalPart = ""] = input.toFixed(2).split(".");
        const integerPartWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (decimalPart === "" || decimalPart === "00") {
          return integerPartWithCommas;
        }
        const formattedDecimalPart = decimalPart.endsWith("0")
          ? decimalPart.charAt(0)
          : decimalPart;
        return `${integerPartWithCommas}.${formattedDecimalPart}`;
      },
      placeholderInTable: (val) => {
        // 1.) { loadingLoop: number, table: number, textLoading: ' ', textEmpty: string, textNotFound: string }
        if (!val.loadingLoop) {
          return val.textLoading || ' '
        } else if (val.loadingLoop === 1 && val.table === 0) {
          return val.textEmpty || ' '
        } else {
          return val.textNotFound || ' '
        }
      },
      fontStyle: (text) => {
        // 1.) { string }
        if (text.match(/[ก-๙]/)) {
          return "font-family: 'Kanit', sans-serif"
        } else {
          return "font-family: 'Lato', sans-serif"
        }
      },
      watchingTrim: (val) => {
        // 1.) { string }
        // 2.) { text: string, min: number }
        let min = val.min || 0
        let textLenght = 0;
        if (typeof val === 'string') {
          textLenght = val.trim().length
        } else if (typeof val === 'number') {
          textLenght = val.toString().trim().length
        } else if (val.text) {
          textLenght = val.text.trim().length
        }
        if (textLenght > min) {
          return true
        } else {
          return false
        }
      },
      validateInt: (val) => {
        // 1.) { any }
        let reg = /^[0-9]*$/
        return reg.test(val)
      },
      validateEmail: (val) => {
        // 1.) { string }
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return reg.test(val)
      },
      mockingID(length) {
        // 1.) { number }
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
      removeHashURL(val) {
        // 1.) { hash:string, anchor:obj, default:string }
        const anchor = val.hash.split('#');
        const checkedHash = val.anchor[anchor[1]];
        // return anchor[1] || false;
        if (anchor[1] && checkedHash) {
          return anchor[1];
        } else {
          return val.default;
        }
      },
      maxHeightChart(val) {
        // 1.) { number }
        let number = Number(val.number) || val;
        let value = val.number || val;
        number = Number(number);
        if (number > 100) {
          if (val.size && val.size < 250) {
            value = (number + number * (20 / 100)).toFixed(0);
          } else {
            value = (number + number * (14 / 100)).toFixed(0);
          }
        } else if (number > 10) {
          value = (number + number * (20 / 100)).toFixed(0);
        } else if (value > 0) {
          value = number + 1;
        } else {
          value = (number + number * (13 / 100)).toFixed(0);
        }
        return value
      },
      waitingTime(ms) {
        // 1.) { number }
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      icons(name) {
        // 1.) { string }
        return require("@/assets/icons/" + name + ".png")
      },
      permissions(val) {
        // 1.) { perm: this.pagePermission, path: string, type: "string", user_type: "" }
        if (val.type == 'disable') {
          const reFormant = val.path.split("-").join("_");
          const user_type = val.user_type;
          if (
            val.perm[reFormant] &&
            val.perm[reFormant][user_type] &&
            !val.perm[reFormant][user_type].disable
          ) {
            return !val.perm[reFormant][user_type].disable;
          } else if (
            val.perm[reFormant] == undefined
          ) {
            return true;
          }
        } else if (val.type == 'lock') {
          const reFormant = val.path.split("-").join("_");
          const user_type = val.user_type;
          if (
            val.perm[reFormant] &&
            val.perm[reFormant][user_type] &&
            !val.perm[reFormant][user_type].disable
          ) {
            return val.perm[reFormant][user_type].lock
          } else if (
            val.perm[reFormant] == undefined
          ) {
            return true;
          }
        }
        console.warn('No type of permissions:', val)
        return false
      },
      powerBreakingPoint(value) {
        // 1.) { number }
        const levelDetail = [
          {
            id: "level_4",
            label: "2",
            unit: "k",
            value: 2000,
          },
          {
            id: "level_3",
            label: "1",
            unit: "k",
            value: 1000,
          },
          {
            id: "level_2",
            label: "500",
            unit: "",
            value: 500,
          },
          {
            id: "level_1",
            label: "250",
            unit: "",
            value: 250,
          },
          {
            id: "level_0",
            label: "0",
            unit: "",
            value: 0,
          },
        ]
        const valueDisplay_K = (value - (value % 1000)) + "";
        const removeZero_K = valueDisplay_K.slice(0, -3) || "";
        if (value < 1) {
          return {
            id: "level_0",
            label: "0",
            unit: "",
            value: 0,
          };
        } else if (value < 2000) {
          for (let i = 0; i < levelDetail.length; i++) {
            if (value > levelDetail[i].value) {
              return levelDetail[i];
            }
          }
        } else if (value < 1000000) {
          return {
            id: "level_" + removeZero_K + 2,
            label: removeZero_K,
            unit: "k",
            value: valueDisplay_K + 0,
          };
        } else {
          const valueDisplay_M = (value - (value % 100000)) + "";
          const removeZero_M = valueDisplay_M.slice(0, -5);
          return {
            id: "level_" + valueDisplay_K + 2,
            label: removeZero_M.slice(0, -1) + "." + removeZero_M.charAt(removeZero_M.length - 1),
            unit: "m",
            value: removeZero_M + 0,
          };
        }
      },
    }
    Vue.mixin({
      data() {
        return {
          get variable() {
            return {
              // Global variables!
              typingTimeout: 200,
              chartOptioins: {
                maintainAspectRatio: false,
                plugins: {
                  title: {
                    display: false,
                  },
                  legend: {
                    display: false,
                    labels: {
                      font: {
                        family: "Lato"
                      }
                    }
                  },
                  datalabels: {
                    weight: "bold",
                    labels: {
                      value: {
                        weight: "bold",
                      },
                      title: {
                        font: {
                          weight: "bold",
                        }
                      },
                    }
                  }
                },
                scales: {
                  y: {
                    stacked: false,
                    ticks: {
                      display: false,
                      beginAtZero: true,
                      stepSize: 20,
                    },
                    grid: {
                      display: false,
                      drawBorder: false,
                    },
                  },
                  x: {
                    grid: {
                      display: false,
                      fontColor: "black",
                    },
                    ticks: {
                      autoSkip: false,
                    }
                  },
                },
                animation: {
                  duration: 1800,
                },
                datasets: {
                  bar: {
                    categoryPercentage: 0.6,
                    borderRadius: 4,
                    borderSkipped: false,
                  }
                }
              },
            }
          }
        }
      },
      methods: {
        $utils(functionName: string, value: any) {
          switch (functionName) {
            case 'acronymName':
              return Vue.prototype.$utilities[functionName](value)
            case 'addCommasInNumber':
              return Vue.prototype.$utilities[functionName](value)
            case 'placeholderInTable':
              return Vue.prototype.$utilities[functionName](value)
            case 'fontStyle':
              return Vue.prototype.$utilities[functionName](value)
            case 'watchingTrim':
              return Vue.prototype.$utilities[functionName](value)
            case 'validateInt':
              return Vue.prototype.$utilities[functionName](value)
            case 'validateEmail':
              return Vue.prototype.$utilities[functionName](value)
            case 'mockingID':
              return Vue.prototype.$utilities[functionName](value)
            case 'removeHashURL':
              return Vue.prototype.$utilities[functionName](value)
            case 'maxHeightChart':
              return Vue.prototype.$utilities[functionName](value)
            case 'waitingTime':
              return Vue.prototype.$utilities[functionName](value)
            case 'icons':
              return Vue.prototype.$utilities[functionName](value)
            case 'permissions':
              return Vue.prototype.$utilities[functionName](value)
            case 'powerBreakingPoint':
              return Vue.prototype.$utilities[functionName](value)
            case 'test':
              console.log('\x1b[33m%s\x1b[0m', '[utils] Utils Work!')
              break
            default:
              console.warn(`[utils] Don't have function: ${functionName}.`)
          }
        }
      }
    })
  }
}

import Vue from 'vue'
Vue.use(utilities)
